//styles
import './style.scss';

//js
import 'select2';
import './scripts/theme/select2-customize';
import './scripts/animations';
import './scripts/sliders';
import './scripts/theme';
import './scripts/opencart-defaults';